/**
 * Service provider for PouchDB
 * @name functions.ts
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Injectable } from '@angular/core';
declare var require: any;
import 'rxjs/add/operator/map';
import { PouchService } from './pouch-service';
@Injectable({
  providedIn: 'root',
})
export class ChartService {
  color = null;
  x_scale = {
    transform: {
      type: 'date',
      all: '%M %d<br>%h:%i<br>%a',
    },
    item: {
      fontSize: 20,
      fontColor: '#505050',
    },
    zooming: true,
    step: 'hour', //set step for scale
    itemsOverlap: false,
    marginBottom: '20px',
    guide: {
      lineColor: '#e2e0e0',
      lineStyle: 'solid',
      lineWidth: 1,
      visible: true,
    },
  };
  x_scale_raw = {
    'max-items': 12,
    item: {
      'font-size': 10,
    },
  };
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  dates = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  hours = ['12am', '1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am', '9am', '10am', '11am', '12noon', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm', '10pm', '11pm'];
  summaryscale: any = {
    values: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    //"line-color": "#f5f5f5",
    'line-width': '1px',
    tick: {
      'line-color': '#f5f5f5',
      placement: 'outer',
      size: 8,
      'line-width': '1px',
    },
    label: {
      text: '',
      fontSize: 16,
      fontColor: '#505050',
    },
    itemsOverlap: false,
    maxItems: 12,
    item: {
      fontSize: 14,
      //angle: -90,
      fontColor: '#505050',
    },
    guide: {
      lineColor: '#f5f5f5',
      lineStyle: 'solid',
      lineWidth: 1,
      visible: true,
    },
  };
  zchart: any = {
    id: 'myChart',
    data: {
      globals: {
        'font-family': 'Lucida Sans Unicode',
        'font-size': '14',
      },
      type: 'line',
      plot: {
        //styles: [ "red", "orange", "yellow", "green", "blue", "purple", "brown", "black" ],
        tooltip: {
          text: '%vt \n %kt',
        },
        //"stacked": true,
        legendItem: {
          fontSize: 16,
          fontColor: '#505050',
        },
        mode: 'normal',
        selectedState: {
          backgroundColor: '#ffa726',
          borderWidth: '0px',
        },
        selectionMode: 'multiple',
      },

      legend: {
        //draggable: true,
        backgroundColor: 'transparent',
        //"border-top": "2px solid blue",
        verticalAlign: 'top',
        borderWidth: 0,
        layout: '1x4',
        x: '0%',
        y: '0%',
        align: 'left',
        width: '100%',
        margin: '0px 10px 15px 20px',
      },
      plotarea: {
        margin: '60 80 80 80',
        marginLeft: 'dynamic',
        marginRight: 'dynamic',
        marginBottom: 'dynamic',
      },
      preview: {
        'border-width': 1,
        handle: {
          'line-width': 0,
          height: 20,
        },
        'adjust-layout': true,
      },
      options: {
        button: {
          'selected-state': {
            'background-color': '#69c',
          },
        },
        buttons: [
          {
            type: 'hour',
            count: 12,
            text: '12h',
          },
          {
            type: 'day',
            count: 1,
            text: '1dy',
          },
          {
            type: 'week',
            count: 1,
            text: '1wk',
          },
          {
            type: 'month',
            count: 1,
            text: '1mt',
          },
          {
            type: 'all',
            text: 'All',
          },
        ],
      },
      scrollX: {},
      scaleX: this.x_scale,
      scaleX2: this.x_scale,
      scaleY: {
        short: true, //To display scale values as short units.
        'thousands-separator': ',',
        minValue: 'auto',
        maxValue: null,
        //offsetX: 20,
        //offsetY: 20,
        label: {
          text: '',
          fontSize: 16,
          fontColor: '#505050',
        },
        item: {
          fontSize: 16,
          fontColor: '#505050',
        },
        guide: {
          lineColor: '#e2e0e0',
          lineStyle: 'solid',
          lineWidth: 1,
          visible: true,
        },
        format: '$%v',
        negation: 'currency',
      },
      scaleY2: {
        short: true,
        minValue: 'auto',
        maxValue: null,
        label: {
          text: '',
          fontSize: 28,
          fontColor: '#505050',
        },
        item: {
          fontSize: 24,
          fontColor: '#505050',
        },
        guide: {
          lineColor: '#e2e0e0',
          lineStyle: 'solid',
          lineWidth: 1,
          visible: true,
        },
      },
      series: [],
      total: 0,
    },
    height: '100%',
    width: '100%',
    modules: 'zoom-buttons',
  };

  /**
   * Constructor
   */
  constructor(private db: PouchService) {}

  init() {
    this.zchart.data.series = [];
    return this.zchart;
  }

  setFont(fontsize, fontcolor) {
    this.zchart.data.plot.legendItem.fontSize = fontsize;
    this.zchart.data.plot.legendItem.fontColor = fontcolor;
    //
    this.zchart.data.scaleX.item.fontSize = this.zchart.data.scaleX2.item.fontSize = this.x_scale.item.fontSize = this.summaryscale.item.fontSize = fontsize - 4;
    this.x_scale.item.fontColor = this.summaryscale.item.fontColor = fontcolor;
    this.zchart.data.scaleY.item.fontSize = this.zchart.data.scaleY2.fontSize = fontsize;
    this.zchart.data.scaleX.item.fontColor = this.zchart.data.scaleX2.item.fontColor = this.zchart.data.scaleY.item.fontColor = this.zchart.data.scaleY2.fontColor = fontcolor;
    this.zchart.data.scaleY.label.fontSize = this.zchart.data.scaleY2.label.fontSize = +fontsize + 4;
    this.zchart.data.scaleY.label.fontColor = this.zchart.data.scaleY2.label.fontColor = +fontcolor + 4;
    this.summaryscale.label.text = '';
  }

  config(options, file, zchart = this.zchart) {
    zchart.data.type = options.charttype;
    //this.setFont(options.fontsize, options.fontcolor);
    zchart.data.scaleY.label.text = options.scaleYlabel;
    zchart.data.scaleY2.label.text = options.scaleY2label;
    if (options.scale == 'scaleX,scaleY') {
      zchart.data['scaleY'].minValue = options.ymin;
      zchart.data['scaleY'].maxValue = options.ymax;
    } else if (options.scale == 'scaleX,scaleY2') {
      zchart.data['scaleY2'].minValue = options.ymin;
      zchart.data['scaleY2'].maxValue = options.ymax;
    }
    if (options.preview) {
      zchart.data.preview = {
        'border-width': 1,
        handle: {
          'line-width': 0,
          height: 20,
        },
        'adjust-layout': true,
      };
    } else {
      zchart.data.preview = null;
    }
    let datafile = file; //changed
    if (options.charttype == 'pie' || options.charttype == 'pie3d') {
      datafile.map((row) => {
        let values = [];
        options.columns_s.map((column) => {
          values.push(parseFloat(row[column]));
        });
        zchart.data.series.push({ values: values, lineWidth: options.lineWidth, text: row[options.xaxis], backgroundColor: this.color, lineColor: this.color, marker: { backgroundColor: this.color, lineColor: this.color } });
      });
      zchart.data.plot['valueBox'] = {
        placement: 'out',
        text: '%t\n%npv%',
        fontFamily: 'Open Sans',
      };
      zchart.modules = '';
      zchart.data.legend = null;
    } else {
      // initializing each yaxis
      let dataarray: any = {}; //dataarray is the yvalues per yaxis
      dataarray[options.xaxis] = [];
      options.columns_s.map((column) => {
        dataarray[column] = []; //for example dataarray[loadkw]=[]
      });
      if (datafile.length > 0) {
        //filling the exact value for each yaxis
        zchart.data.total = 0;
        datafile.map((row) => {
          dataarray[options.xaxis].push(row[options.xaxis]);
          for (var i = 0; i < options.columns_s.length; i++) {
            if (!isNaN(row[options.columns_s[i]])) {
              dataarray[options.columns_s[i]].push(parseFloat(row[options.columns_s[i]]));
              if (row[options.columns_s[i]] == undefined) {
                zchart.data.total += 1;
              } else {
                zchart.data.total += parseFloat(row[options.columns_s[i]]);
              }
            }
          }
        });
        //sorting summary
        if (options.summary && options.datetime) {
          zchart.modules = 'selection-tool';
          let summaryarray = [];
          let _summaryscale = { ...this.summaryscale };
          let values;
          for (var j = 0; j < options.columns_s.length; j++) {
            if (options.summarytype == '28') {
              _summaryscale.values = this.getLast28Days();
              _summaryscale.maxItems = 28;
              _summaryscale.label.text = 'Last 28 Days';
              zchart.data.scaleX = _summaryscale;
              // let index = this[options.summarytype + 's'];
              values = new Array(28).fill(0);
              summaryarray = Array.from({ length: 28 }, (e) => new Array());
            } else {
              _summaryscale.label.text = '';
              let index = options.summarytype == 'date' ? this[options.summarytype + 's'] : this.translateArray(this[options.summarytype + 's']);
              values = new Array(index.length).fill(0);
              summaryarray = Array.from({ length: index.length }, (e) => new Array());
              _summaryscale.values = index;
              _summaryscale.maxItems = index.length;
              /* if(options.summarytype == 'day'){
                  _summaryscale.label.text = "";
              } */
              zchart.data.scaleX = _summaryscale;
            }
            let a = 0;
            for (var i = 0; i < dataarray[options.xaxis].length; i++) {
              let d: any = new Date(dataarray[options.xaxis][i]);
              if (file[i][options.columns_s[j]] == undefined) {
                a = 1;
                //summaryarray[d.getHours()].push(a);
                zchart.data.scaleY.format = '%v';
                zchart.data.scaleY.negation = null;
              } else if (options.columns_s[j] == 'amount') {
                a = parseFloat(file[i][options.columns_s[j]]);
                //summaryarray[d.getHours()].push(a);
                zchart.data.scaleY.format = (options.currency ? options.currency : '₦') + '%v';
                zchart.data.scaleY.negation = 'currency';
              } else {
                a = parseFloat(file[i][options.columns_s[j]]);
                //summaryarray[d.getHours()].push(a);
                zchart.data.scaleY.format = '%v';
                zchart.data.scaleY.negation = null;
              }
              //type
              if (options.summarytype == 'month') {
                summaryarray[d.getMonth()]?.push(a);
              } else if (options.summarytype == 'day') {
                summaryarray[d.getDay()]?.push(a);
              } else if (options.summarytype == 'hour') {
                summaryarray[d.getHours()]?.push(a);
              } else if (options.summarytype == 'date') {
                summaryarray[d.getDate() - 1]?.push(a);
              } else if (options.summarytype == '28') {
                // get difference in days between today and the date d
                let diff = Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(d).setHours(0, 0, 0, 0)) / (1000 * 60 * 60 * 24));
                summaryarray[27 - diff]?.push(a);
              }
            }
            for (var k = 0; k < summaryarray.length; k++) {
              if (summaryarray[k].length != 0) {
                if (options.summaryvalue == 'sum') {
                  values[k] = summaryarray[k].reduce(function (a, b) {
                    return a + b;
                  });
                } else if (options.summaryvalue == 'avg') {
                  values[k] =
                    summaryarray[k].reduce(function (a, b) {
                      return a + b;
                    }) / summaryarray[k].length;
                } else if (options.summaryvalue == 'max') {
                  values[k] = Math.max(...summaryarray[k]);
                } else if (options.summaryvalue == 'min') {
                  values[k] = Math.min(...summaryarray[k]);
                }
              }
            }
            // remove old data
            zchart.data.series = zchart.data.series.filter((series) => {
              return series.text != options.mode;
            });

            zchart.data.series.push({ values: values, lineWidth: options.lineWidth, text: options.mode == 'product' || options.mode == 'service' || options.filename ? options.filename : this.capitalizeFirstLetter(options.mode), legendItem: {}, scales: options.scale, backgroundColor: this.color, lineColor: this.color, marker: { backgroundColor: this.color, lineColor: this.color } });
          }
        } else {
          zchart.modules = 'zoom-buttons';
          zchart.data.scaleX = this.x_scale;
          for (var j = 0; j < options.columns_s.length; j++) {
            let values = [];
            let index = [];
            for (var i = 0; i < dataarray[options.xaxis].length; i++) {
              if (options.datetime) {
                values.push([new Date(dataarray[options.xaxis][i]).getTime(), dataarray[options.columns_s[j]][i]]);
              } else {
                values.push([dataarray[options.xaxis][i], dataarray[options.columns_s[j]][i]]);
                index.push(dataarray[options.xaxis][i]);
              }
            }
            if (!options.datetime) {
              let _summaryscale = { ...this.summaryscale };
              _summaryscale.values = index;
              _summaryscale.maxItems = index.length;
              zchart.data.scaleX = _summaryscale; //change to raw scale
              zchart.modules = '';
            }
            zchart.data.series.push({ values: values, lineWidth: options.lineWidth, text: options.mode == 'product' || options.mode == 'service' ? options.filename : this.capitalizeFirstLetter(options.mode), legendItem: {}, scales: options.scale, backgroundColor: this.color, lineColor: this.color, marker: { backgroundColor: this.color, lineColor: this.color } });
          }
          if (new Date(datafile[1].Date).getTime() - new Date(datafile[0].Date).getTime() < 61000) {
            //minute
            zchart.data.options.buttons.unshift({
              type: 'hour',
              count: 1,
              text: 'hr',
            });
          }

          if (new Date(datafile[1].Date).getTime() - new Date(datafile[0].Date).getTime() < 11000) {
            //minute
            zchart.data.options.buttons.unshift({
              type: 'minute',
              count: 1,
              text: 'min',
            });
            zchart.data.scaleX.step = 'minute';
          }
        }
      }
    }
    this.color = null;
    return zchart;
  }

  // replace underscore with space and capitalize the first letter after space
  capitalizeFirstLetter(string) {
    if (this.db.language == 'en') {
      return string.replace(/_/g, ' ').replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    } else {
      return this.db.rename(string, this.db.language);
    }
  }

  live() {
    let livechart = Object.assign({}, this.zchart);
    livechart.data.type = 'area';
    livechart.data.refresh = {
      type: 'feed',
      transport: 'js',
      url: 'feeder()',
      interval: 200,
    };
    livechart.data.series = [
      {
        values: [],
        text: 'Expected Demand',
      },
      {
        values: [],
        text: 'Demand Response',
      },
    ];
    return livechart;
  }

  getLast28Days() {
    // Create an array to hold the dates
    let dates = [];

    // Get today's date
    let currentDate = new Date();

    // Loop 28 times to generate the last 28 days
    for (let i = 27; i >= 0; i--) {
      // Create a new date for each day
      let date = new Date(currentDate);
      // Subtract 'i' days from the current date
      date.setDate(date.getDate() - i);
      // Format the date and push it to the 'dates' array
      dates.push(date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }));
    }

    return dates;
  }
  translateArray(array) {
    let translated = [];
    array.map((item) => {
      translated.push(this.db.rename(item, this.db.language));
    });
    return translated;
  }
}
